import { Box } from '@chakra-ui/react';
import React from 'react';
import { Element as SharedElement } from '@lon/shared/components';
import { sxLightScrollBar } from '@lon/shared/constants';

const StudentResource: React.FC = () => {
  return (
    <Box height="100vh" overflow="auto" sx={sxLightScrollBar}>
      <SharedElement hasToolbar={false} isDisabledBreadcrumbs />
    </Box>
  );
};

export default StudentResource;
